import * as Yup from 'yup'



export const validationSchemas = (isRegistraHito) => {
   
  let validationObject = { };
  if(isRegistraHito){

   validationObject["fechaHitoContacto"] = Yup.date().required('La Fecha es obligatoria.');
  }
  validationObject["minutaHitoContacto"] = Yup.string().test(
    "len",
    "No puede exeder 1000 caracteres..",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 0 && val.length <= 1000);
    }
  );
//   if(isRespuestaContacto){

//    validationObject["fechaHitoRespuesta"] = Yup.date().required('La Fecha es obligatoria.');
//   }
//   validationObject["idCarpetaResExt"] = Yup.string().test(
//     "len",
//     "No puede exeder 20 caracteres..",
//     (val) => {
//       if (val === undefined) {
//         return true;
//       }
//       return val.length === 0 || (val.length >= 0 && val.length <= 20);
//     }
//   );
//   validationObject["minutaHitoRespuesta"] = Yup.string().test(
//     "len",
//     "No puede exeder 1000 caracteres..",
//     (val) => {
//       if (val === undefined) {
//         return true;
//       }
//       return val.length === 0 || (val.length >= 0 && val.length <= 1000);
//     }
//   );
  return Yup.object().shape(validationObject);
}

